
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/12v-lithium-battery",
      function () {
        return require("private-next-pages/12v-lithium-battery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/12v-lithium-battery"])
      });
    }
  